import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap'
import { rcService } from '../../services'
import { rcActions } from '../../redux/actions'

import FormattedMessage from '../FormattedMessage/FormattedMessage'
import Loader from '../Loader/Loader'
import MyRewardsErrorModal from '../Modal/MyRewardsErrorModal/MyRewardsErrorModal'
import MyRewardsSuccessModal from '../Modal/MyRewardsSuccessModal/MyRewardsSuccessModal'

function RCIntegration(props) {
  const dispatch = useDispatch()
  const [btnText, setBtnText] = useState('robotcache.button.connect')
  const [loading, setLoading] = useState(false)
  const [modal, toggleModal] = useState(false)
  const [isListener, setIsListener] = useState(false)
  const [isRedeemed, setIsRedeemed] = useState(false)
  const [couponCode, setCouponCode] = useState(props.couponCode)
  const [contentId, setContentId] = useState(props.contentId)
  const [contentName, setContentName] = useState(props.contentName)
  const [activationKey, setactivationKey] = useState(props.activationKey)
  const [rcError, setRcError] = useState(false)
  const [rcSuccess, setRcSuccess] = useState(false)
  const [errorString, setErrorString] = useState(null)

  const authenticated = useSelector(state => state.rcReducer.authenticated)
  const token = useSelector(state => state.rcReducer.token)

  useEffect(() => {
    if (!authenticated) {
      dispatch(rcActions.checkUserToken())
    }
    if (!isListener) {
      window.addEventListener(
        'message',
        e => {
          if (
            e.data === 'rcRedirect' &&
            e.origin ===
              `${encodeURI(document.location.protocol)}//${encodeURI(document.location.host)}`
          ) {
            setLoading(true)
            toggleModal(false)
            dispatch(rcActions.checkUserToken())
          }
        },
        false
      )
      setIsListener(true)
    }
    setLoading(false)
    if (isRedeemed) {
      setBtnText('robotcache.button.play')
    } else if (authenticated) {
      setBtnText('robotcache.button.activate')
    } else {
      setBtnText('robotcache.button.connect')
    }
  }, [isListener, authenticated, token, isRedeemed, dispatch])

  const handleBtnAction = async () => {
    if (isRedeemed) {
      const externalUrl = `https://store.${process.env.RAZZLE_RC_BASE_URL}`
      return window.open(externalUrl)
    }
    if (authenticated) {
      setLoading(true)
      const response = await rcService.activateGame(token, couponCode, contentId, activationKey)
      if (response.status === 200) {
        setIsRedeemed(true)
        setRcSuccess(true)
      } else {
        if (response.errors === 'error.robotcache.codealreadyredeemed') {
          setIsRedeemed(true)
          setRcSuccess(true)
        } else {
          setIsRedeemed(true)
          if (
            response.errors === 'error.robotcache.500tokeninvalid' ||
            response.errors === 'error.robotcache.500robotcacheaccount'
          ) {
            handleLogout()
          }
        }
        setRcError(true)
        setErrorString(response.errors)
      }
      setLoading(false)
    } else {
      toggleModal(true)
    }
  }

  const handleLogout = () => {
    dispatch(rcActions.removeUserAuth())
  }

  const toggleError = () => {
    setRcError(!rcError)
  }

  const toggleSuccess = () => {
    setRcSuccess(!rcSuccess)
  }

  if (loading) {
    return <Loader button />
  }

  return (
    <>
      <div className="mb-3">
        <div className="row">
          <div className="col">
            <Button
              color="dark"
              block
              outline
              onClick={handleBtnAction}
              aria-describedby="rc-integration-status"
            >
              <FormattedMessage id={btnText} />
            </Button>
            {authenticated && token && (
              <a
                className="logout"
                onClick={handleLogout}
                role="button"
                tabIndex={0}
                aria-label="Logout from RobotCache account"
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    handleLogout()
                  }
                }}
              >
                <u>
                  <FormattedMessage id="robotcache.button.logout" />
                </u>
              </a>
            )}
          </div>
        </div>
      </div>
      <div id="rc-integration-status" className="sr-only">
        {isRedeemed
          ? 'Game activated successfully'
          : authenticated
          ? 'Logged into RobotCache'
          : 'Not logged in'}
      </div>
      <MyRewardsErrorModal
        isOpen={rcError}
        toggle={toggleError}
        error={errorString}
        platform="rc"
      />
      <MyRewardsSuccessModal
        isOpen={rcSuccess}
        toggle={toggleSuccess}
        contentName={contentName}
        platform="rc"
      />
      <Modal
        isOpen={modal}
        toggle={() => toggleModal()}
        style={{ maxWidth: '580px' }}
        role="dialog"
        aria-labelledby="rc-login-modal-title"
        aria-describedby="rc-login-modal-body"
      >
        <ModalHeader
          toggle={() => toggleModal()}
          id="rc-login-modal-title"
          aria-label="RobotCache login"
        />
        <ModalBody style={{ minHeight: '800px' }} id="rc-login-modal-body">
          {modal && (
            <iframe
              className="iFrame"
              title="RobotCache authentication iframe"
              src={`https://auth.${
                process.env.RAZZLE_RC_BASE_URL
              }/Account/ThirdPartyLogin?PartnerName=${
                process.env.RAZZLE_RC_COMPANY
              }&CallbackUrl=${encodeURI(document.location.protocol)}//${encodeURI(
                document.location.host
              )}/rc-redirect`}
              width={480}
              height={720}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default RCIntegration
